module.exports = __webpack_public_path__ + "img/e182115a-63d2-42ce-8fe0-5f696ecdfba6.0516fcb6.jpg";